export default from './LoggedOutInfoMessage'


// WEBPACK FOOTER //
// ./src/components/Elements/LoggedOutInfoMessage/index.js